import { useState, useEffect } from 'react';
import S from './BroadcastQueueCheckboxStyles';

type Props = {
  state?: boolean;
  disabled?: boolean;
  name?: string;
  onChange: (name: string, checked: boolean) => void;
};

export default function BroadcastQueueCheckbox({
  disabled = false,
  name,
  state = false,
  onChange,
}: Props): JSX.Element {
  const [checkedState, setCheckedState] = useState(state);

  useEffect(() => {
    setCheckedState(state);
  }, [state]);

  const handleClick = (): void => {
    if (!disabled) {
      const newChecked = !checkedState;
      setCheckedState(newChecked);
      onChange(name ?? '', newChecked);
    }
  };

  return (
    <S.Wrapper
      onClick={handleClick}
      className={disabled ? 'disabled' : ''}
      role="checkbox"
      tabIndex={0}
      onKeyDown={(e): void => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
      aria-checked={checkedState}
      aria-label={name ? `Select ${name}` : 'Toggle'}
    >
      <input type="checkbox" name={name} checked={checkedState} readOnly onChange={(): void => {}} />
      <span className="checkbox-box" />
    </S.Wrapper>
  );
}
